import React, { useEffect } from "react";
import { Link } from "react-router";
import DOMPurify from "dompurify";
import "./generic.scss";

export default function Button({
  children,
  href,
  action = null,
  submit = false,
  disabled = false,
  title,
  target = "_blank",
  loading = false,
  id = "",
  ariaLabel = "Weiter",
  btnClass
}) {
  const Loading = () => <div className="loader-indicator"></div>;

  function validateLink(link) {
    let temp = link;

    if (action === null && temp === undefined && submit === false) {
      return (
        <div className={`button ${disabled ? "disabled" : ""}`} title={title}>
          <div className="button-inner">{children}</div>
        </div>
      );
    } else if (submit === true) {
      return (
        <button
          aria-label={ariaLabel}
          type="submit"
          value={children}
          className={`button ${disabled ? "disabled" : ""}`}
          disabled={disabled}
          title={title}
        >
          <div className="button-inner">{children}</div>
        </button>
      );
    } else if (action !== null && link === undefined) {
      return (
        <button
          aria-label={ariaLabel}
          className={`button ${disabled || loading ? "disabled" : ""}`}
          onClick={action}
          title={title}
          disabled={disabled || loading}
        >
          {!loading ? (
            <div className="button-inner">{children}</div>
          ) : (
            <Loading />
          )}
        </button>
      );
    } else if (temp.includes("http://") || temp.includes("https://")) {
      return (
        <a
          href={DOMPurify.sanitize(href)}
          target={target}
          rel="noopener noreferrer"
          className={`button ${disabled ? "disabled" : ""}`}
          title={title}
          onClick={action}
        >
          <div className="button-inner">{children}</div>
        </a>
      );
    } else {
      return (
        <Link
          to={DOMPurify.sanitize(href)}
          className={`button ${disabled || loading ? "disabled" : ""}`}
          title={title}
          onClick={action}
        >
          {!loading ? (
            <div className="button-inner">{children}</div>
          ) : (
            <Loading />
          )}
        </Link>
      );
    }
  }

  return (
    <div
      id={id}
      className={`button-component ${disabled || loading ? "disabled" : ""} ${btnClass ? btnClass : ""}`}
    >
      {validateLink(href)}
    </div>
  );
}
